export enum FormTypeEnum {
  'video' = 'video',
  'evaluation' = 'evaluation',
  'additionnal' = 'additionnal',
}
